import { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import { ScreenType } from 'core/flow/entities';

interface ScreenComponentDefinition {
  Screen: ComponentType<{ id: string }>;
  importChunk: () => Promise<unknown>;
}

export const screenComponents: Partial<Record<ScreenType, ScreenComponentDefinition>> = {
  [ScreenType.TIME_V2]: {
    Screen: dynamic(() => import('./TimeV2').then((mod) => mod.TimeV2)),
    importChunk: () => import('./TimeV2'),
  },
  [ScreenType.CONTENT_REPRESENTATION_QUESTION]: {
    Screen: dynamic(() =>
      import('./ContentRepresentationQuestion').then((mod) => mod.ContentRepresentationQuestion),
    ),
    importChunk: () => import('./ContentRepresentationQuestion'),
  },
  [ScreenType.DATE_PICKER_V2]: {
    Screen: dynamic(() => import('./DatePickerV2').then((mod) => mod.DatePickerV2)),
    importChunk: () => import('./DatePickerV2'),
  },
  [ScreenType.GENDER]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.Gender)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.GENDER_PALMISTRY]: {
    Screen: dynamic(() => import('./GenderPalmistry').then((mod) => mod.GenderPalmistry)),
    importChunk: () => import('./GenderPalmistry'),
  },
  [ScreenType.VIDEO_QUIZ]: {
    Screen: dynamic(() => import('./VideoQuiz').then((mod) => mod.VideoQuiz)),
    importChunk: () => import('./VideoQuiz'),
  },
  [ScreenType.PRELANDING_PALMISTRY]: {
    Screen: dynamic(() => import('./PrelandingPalmistry').then((mod) => mod.PrelandingPalmistry)),
    importChunk: () => import('./PrelandingPalmistry'),
  },
  [ScreenType.GOAL]: {
    Screen: dynamic(() => import('./Goal').then((mod) => mod.Goal)),
    importChunk: () => import('./Goal'),
  },
  [ScreenType.GOAL_SET]: {
    Screen: dynamic(() => import('./GoalSet').then((mod) => mod.GoalSet)),
    importChunk: () => import('./GoalSet'),
  },
  [ScreenType.PLACE]: {
    Screen: dynamic(() => import('./Place').then((mod) => mod.Place)),
    importChunk: () => import('./Place'),
  },
  [ScreenType.PLACE_NATAL_CHART]: {
    Screen: dynamic(() => import('./PlaceNatalChart').then((mod) => mod.PlaceNatalChart)),
    importChunk: () => import('./PlaceNatalChart'),
  },
  [ScreenType.NAME_V2]: {
    Screen: dynamic(() => import('./NameV2').then((mod) => mod.NameV2)),
    importChunk: () => import('./NameV2'),
  },
  [ScreenType.FREE_INPUT_V2]: {
    Screen: dynamic(() => import('./NameV2').then((mod) => mod.NameV2)),
    importChunk: () => import('./NameV2'),
  },
  [ScreenType.ANSWER]: {
    Screen: dynamic(() => import('./Answer').then((mod) => mod.Answer)),
    importChunk: () => import('./Answer'),
  },
  [ScreenType.ANSWER_EMOJI]: {
    Screen: dynamic(() => import('./AnswerEmoji').then((mod) => mod.AnswerEmoji)),
    importChunk: () => import('./AnswerEmoji'),
  },
  [ScreenType.ANSWER_PALMISTRY]: {
    Screen: dynamic(() => import('./AnswerPalmistry').then((mod) => mod.AnswerPalmistry)),
    importChunk: () => import('./AnswerPalmistry'),
  },
  [ScreenType.ANSWER_NATAL_CHART]: {
    Screen: dynamic(() => import('./AnswerNatalChart').then((mod) => mod.AnswerNatalChart)),
    importChunk: () => import('./AnswerNatalChart'),
  },
  [ScreenType.ANSWER_GOAL_NATAL_CHART]: {
    Screen: dynamic(() => import('./AnswerNatalChartV2').then((mod) => mod.AnswerNatalChartV2)),
    importChunk: () => import('./AnswerNatalChartV2'),
  },
  [ScreenType.ANSWER_NATAL_CHART_V2]: {
    Screen: dynamic(() => import('./AnswerNatalChartV2').then((mod) => mod.AnswerNatalChartV2)),
    importChunk: () => import('./AnswerNatalChartV2'),
  },
  [ScreenType.PRELANDING_VIDEO]: {
    Screen: dynamic(() => import('./PrelandingVideo').then((mod) => mod.PrelandingVideo)),
    importChunk: () => import('./PrelandingVideo'),
  },
  [ScreenType.ANSWER_DETAILED_OTHER]: {
    Screen: dynamic(() => import('./AnswerDetailedOther').then((mod) => mod.AnswerDetailedOther)),
    importChunk: () => import('./AnswerDetailedOther'),
  },
  [ScreenType.ANSWER_HORIZONTAL_ORIENTATION]: {
    Screen: dynamic(() =>
      import('./AnswerHorizontalOrientation').then((mod) => mod.AnswerHorizontalOrientation),
    ),
    importChunk: () => import('./AnswerHorizontalOrientation'),
  },
  [ScreenType.ANSWER_HORIZONTAL_ORIENTATION_V2]: {
    Screen: dynamic(() =>
      import('./AnswerHorizontalOrientationV2').then((mod) => mod.AnswerHorizontalOrientationV2),
    ),
    importChunk: () => import('./AnswerHorizontalOrientationV2'),
  },
  [ScreenType.MULTIPLE_ANSWERS_V2]: {
    Screen: dynamic(() => import('./MultipleAnswersV2').then((mod) => mod.MultipleAnswersV2)),
    importChunk: () => import('./MultipleAnswersV2'),
  },
  [ScreenType.PROCESSING]: {
    Screen: dynamic(() => import('./Processing').then((mod) => mod.Processing)),
    importChunk: () => import('./Processing'),
  },
  [ScreenType.PROCESSING_PALMISTRY]: {
    Screen: dynamic(() => import('./ProcessingPalmistry').then((mod) => mod.ProcessingPalmistry)),
    importChunk: () => import('./ProcessingPalmistry'),
  },
  [ScreenType.PROCESSING_NATAL_CHART]: {
    Screen: dynamic(() => import('./ProcessingNatalChart').then((mod) => mod.ProcessingNatalChart)),
    importChunk: () => import('./ProcessingNatalChart'),
  },
  [ScreenType.PROBLEM]: {
    Screen: dynamic(() => import('./Problem').then((mod) => mod.Problem)),
    importChunk: () => import('./Problem'),
  },
  [ScreenType.REVIEW]: {
    Screen: dynamic(() => import('./Review').then((mod) => mod.Review)),
    importChunk: () => import('./Review'),
  },
  [ScreenType.PROCESSING_LOADER]: {
    Screen: dynamic(() => import('./ProcessingLoader').then((mod) => mod.ProcessingLoader)),
    importChunk: () => import('./ProcessingLoader'),
  },
  [ScreenType.EMAIL_V2]: {
    Screen: dynamic(() => import('./EmailV2').then((mod) => mod.EmailV2)),
    importChunk: () => import('./EmailV2'),
  },
  [ScreenType.EMAIL_CONFIRM]: {
    Screen: dynamic(() => import('./EmailConfirm').then((mod) => mod.EmailConfirm)),
    importChunk: () => import('./EmailConfirm'),
  },
  [ScreenType.ONBOARDING]: {
    Screen: dynamic(() => import('./Onboarding').then((mod) => mod.Onboarding)),
    importChunk: () => import('./Onboarding'),
  },
  [ScreenType.ONBOARDING_PALMISTRY]: {
    Screen: dynamic(() => import('./OnboardingPalmistry').then((mod) => mod.OnboardingPalmistry)),
    importChunk: () => import('./OnboardingPalmistry'),
  },
  [ScreenType.SCAN_PREVIEW]: {
    Screen: dynamic(() => import('./ScanPreview').then((mod) => mod.ScanPreview)),
    importChunk: () => import('./ScanPreview'),
  },
  [ScreenType.SCAN]: {
    Screen: dynamic(() => import('./Scan').then((mod) => mod.Scan)),
    importChunk: () => import('./Scan'),
  },
  [ScreenType.SCAN_ANALYSING]: {
    Screen: dynamic(() => import('./ScanAnalysing').then((mod) => mod.ScanAnalysing)),
    importChunk: () => import('./ScanAnalysing'),
  },
  [ScreenType.SCAN_ANALYSING_WITH_UPDATE_SETTINGS]: {
    Screen: dynamic(() =>
      import('./ScanAnalysing').then((mod) => mod.ScanAnalysingWithUpdateSettings),
    ),
    importChunk: () => import('./ScanAnalysing'),
  },
  [ScreenType.REPORT]: {
    Screen: dynamic(() => import('./Report').then((mod) => mod.Report)),
    importChunk: () => import('./Report'),
  },
  [ScreenType.SINGLE_ZODIAC_INFO]: {
    Screen: dynamic(() => import('./SingleZodiacInfo').then((mod) => mod.SingleZodiacInfo)),
    importChunk: () => import('./SingleZodiacInfo'),
  },
  [ScreenType.RELATIONSHIP_ZODIAC_INFO]: {
    Screen: dynamic(() =>
      import('./RelationshipZodiacInfo').then((mod) => mod.RelationshipZodiacInfo),
    ),
    importChunk: () => import('./RelationshipZodiacInfo'),
  },
  [ScreenType.MENTIONED_IN]: {
    Screen: dynamic(() => import('./MentionedIn').then((mod) => mod.MentionedIn)),
    importChunk: () => import('./MentionedIn'),
  },
  [ScreenType.TRIAL_CHOICE]: {
    Screen: dynamic(() => import('./TrialChoice').then((mod) => mod.TrialChoice)),
    importChunk: () => import('./TrialChoice'),
  },
  [ScreenType.TRIAL_CHOICE_PALMISTRY_V2]: {
    Screen: dynamic(() =>
      import('./TrialChoicePalmistryV2').then((mod) => mod.TrialChoicePalmistryV2),
    ),
    importChunk: () => import('./TrialChoicePalmistryV2'),
  },
  [ScreenType.TRIAL_PAYMENT_SECTIONS]: {
    Screen: dynamic(() => import('./TrialPayment').then((mod) => mod.TrialPaymentSections)),
    importChunk: () => import('./TrialPayment'),
  },
  [ScreenType.TRIAL_PAYMENT_NATAL_CHART_SECTIONS]: {
    Screen: dynamic(() =>
      import('./TrialPaymentNatalChart').then((mod) => mod.TrialPaymentNatalChartSections),
    ),
    importChunk: () => import('./TrialPaymentNatalChart'),
  },
  [ScreenType.TRIAL_PAYMENT_PAYWALL]: {
    Screen: dynamic(() => import('./TrialPaymentPaywall').then((mod) => mod.TrialPaymentPaywall)),
    importChunk: () => import('./TrialPaymentPaywall'),
  },
  [ScreenType.UPSELLS]: {
    Screen: dynamic(() => import('./Upsells').then((mod) => mod.Upsells)),
    importChunk: () => import('./Upsells'),
  },
  [ScreenType.UPSELLS_NATAL_CHART]: {
    Screen: dynamic(() => import('./UpsellsNatalChart').then((mod) => mod.UpsellsNatalChart)),
    importChunk: () => import('./UpsellsNatalChart'),
  },
  [ScreenType.UPSELLS_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./UpsellsPalmistryV2').then((mod) => mod.UpsellsPalmistryV2)),
    importChunk: () => import('./UpsellsPalmistryV2'),
  },
  [ScreenType.TRIAL_CREDITS]: {
    Screen: dynamic(() => import('./TrialCredits').then((mod) => mod.TrialCredits)),
    importChunk: () => import('./TrialCredits'),
  },
  [ScreenType.TRIAL_CREDITS_NATAL_CHART]: {
    Screen: dynamic(() =>
      import('./TrialCreditsNatalChart').then((mod) => mod.TrialCreditsNatalChart),
    ),
    importChunk: () => import('./TrialCreditsNatalChart'),
  },
  [ScreenType.TRIAL_CREDITS_PALMISTRY]: {
    Screen: dynamic(() =>
      import('./TrialCreditsPalmistry').then((mod) => mod.TrialCreditsPalmistry),
    ),
    importChunk: () => import('./TrialCreditsPalmistry'),
  },
  [ScreenType.TRIAL_CREDITS_PALMISTRY_V2]: {
    Screen: dynamic(() =>
      import('./TrialCreditsPalmistryV2').then((mod) => mod.TrialCreditsPalmistryV2),
    ),
    importChunk: () => import('./TrialCreditsPalmistryV2'),
  },
  [ScreenType.ONBOARDING_ASK_V2]: {
    Screen: dynamic(() => import('./OnboardingAskV2').then((mod) => mod.OnboardingAskV2)),
    importChunk: () => import('./OnboardingAskV2'),
  },
  [ScreenType.PHONE_NUMBER_PALMISTRY]: {
    Screen: dynamic(() => import('./PhoneNumberPalmistry').then((mod) => mod.PhoneNumberPalmistry)),
    importChunk: () => import('./PhoneNumberPalmistry'),
  },
  [ScreenType.WHICH_FIGURE]: {
    Screen: dynamic(() => import('./WhichFigure').then((mod) => mod.WhichFigure)),
    importChunk: () => import('./WhichFigure'),
  },
  [ScreenType.MOON_PHASE]: {
    Screen: dynamic(() => import('./MoonPhase').then((mod) => mod.MoonPhase)),
    importChunk: () => import('./MoonPhase'),
  },
  [ScreenType.PARTNER_MOON_PHASE]: {
    Screen: dynamic(() => import('./PartnerMoonPhase').then((mod) => mod.PartnerMoonPhase)),
    importChunk: () => import('./PartnerMoonPhase'),
  },
  [ScreenType.THANK_YOU]: {
    Screen: dynamic(() => import('./ThankYou').then((mod) => mod.ThankYou)),
    importChunk: () => import('./ThankYou'),
  },
  [ScreenType.NATAL_CHART]: {
    Screen: dynamic(() => import('./NatalChart').then((mod) => mod.NatalChart)),
    importChunk: () => import('./NatalChart'),
  },
  [ScreenType.NATAL_CHART_REPORT]: {
    Screen: dynamic(() => import('./NatalChartReport').then((mod) => mod.NatalChartReport)),
    importChunk: () => import('./NatalChartReport'),
  },
  [ScreenType.LOADING_MOON_COMPATIBILITY]: {
    Screen: dynamic(() =>
      import('./LoadingMoonCompatibility').then((mod) => mod.LoadingMoonCompatibility),
    ),
    importChunk: () => import('./LoadingMoonCompatibility'),
  },
  [ScreenType.HELLO_MOON_COMPATIBILITY]: {
    Screen: dynamic(() =>
      import('./HelloMoonCompatibility').then((mod) => mod.HelloMoonCompatibility),
    ),
    importChunk: () => import('./HelloMoonCompatibility'),
  },
  [ScreenType.EMAIL_MARKETING_COMPATIBILITY]: {
    Screen: dynamic(() =>
      import('./EmailMarketingCompatibility').then((mod) => mod.EmailMarketingCompatibility),
    ),
    importChunk: () => import('./EmailMarketingCompatibility'),
  },
  [ScreenType.EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT]: {
    Screen: dynamic(() =>
      import('./EmailMarketingCompatibilityOneTimePayment').then(
        (mod) => mod.EmailMarketingCompatibilityOneTimePayment,
      ),
    ),
    importChunk: () => import('./EmailMarketingCompatibilityOneTimePayment'),
  },
  [ScreenType.SPLIT]: {
    Screen: dynamic(() => import('./Split').then((mod) => mod.default)),
    importChunk: () => import('./Split'),
  },
  [ScreenType.RELATIONSHIP_PROGRESS]: {
    Screen: dynamic(() => import('./RelationshipProgress').then((mod) => mod.RelationshipProgress)),
    importChunk: () => import('./RelationshipProgress'),
  },
  [ScreenType.GENDER_V2]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.GenderV2)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.INFORMATIONAL_DYNAMIC]: {
    Screen: dynamic(() => import('./InformationalDynamic').then((mod) => mod.InformationalDynamic)),
    importChunk: () => import('./InformationalDynamic'),
  },
  [ScreenType.INFORMATIONAL_ANIMATED]: {
    Screen: dynamic(() =>
      import('./InformationalAnimated').then((mod) => mod.InformationalAnimated),
    ),
    importChunk: () => import('./InformationalAnimated'),
  },
  [ScreenType.SCRATCH_CARD]: {
    Screen: dynamic(() => import('./ScratchCard').then((mod) => mod.ScratchCard)),
    importChunk: () => import('./ScratchCard'),
  },
  [ScreenType.SOCIAL_PROOF]: {
    Screen: dynamic(() => import('./SocialProof').then((mod) => mod.SocialProof)),
    importChunk: () => import('./SocialProof'),
  },
  [ScreenType.SOCIAL_PROOF_V2]: {
    Screen: dynamic(() => import('./SocialProofV2').then((mod) => mod.SocialProofV2)),
    importChunk: () => import('./SocialProofV2'),
  },
  [ScreenType.ANSWER_IMAGE]: {
    Screen: dynamic(() => import('./AnswerImage').then((mod) => mod.AnswerImage)),
    importChunk: () => import('./AnswerImage'),
  },
  [ScreenType.ANSWER_IMAGE_MULTIPLE]: {
    Screen: dynamic(() => import('./AnswerImageMultiple').then((mod) => mod.AnswerImageMultiple)),
    importChunk: () => import('./AnswerImageMultiple'),
  },
  [ScreenType.UPSELL_CONSULTATION]: {
    Screen: dynamic(() => import('./UpsellConsultation').then((mod) => mod.UpsellConsultation)),
    importChunk: () => import('./UpsellConsultation'),
  },
  [ScreenType.UPSELLS_V2]: {
    Screen: dynamic(() => import('./UpsellsV2').then((mod) => mod.UpsellsV2)),
    importChunk: () => import('./UpsellsV2'),
  },
  [ScreenType.SUMMARY]: {
    Screen: dynamic(() => import('./Summary').then((mod) => mod.Summary)),
    importChunk: () => import('./Summary'),
  },
  [ScreenType.SUMMARY_V3]: {
    Screen: dynamic(() => import('./SummaryV3').then((mod) => mod.SummaryV3)),
    importChunk: () => import('./SummaryV3'),
  },
  [ScreenType.TIMELINE]: {
    Screen: dynamic(() => import('./Timeline').then((mod) => mod.Timeline)),
    importChunk: () => import('./Timeline'),
  },
  [ScreenType.LOADER_WITH_REVIEWS]: {
    Screen: dynamic(() => import('./LoaderWithReviews').then((mod) => mod.LoaderWithReviews)),
    importChunk: () => import('./LoaderWithReviews'),
  },
  [ScreenType.EMAIL_MARKETING_PAYWALL]: {
    Screen: dynamic(() => import('./EmailMarketingPaywall').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingPaywall'),
  },
  [ScreenType.EMAIL_MARKETING_ONE_TIME_PAYMENT]: {
    Screen: dynamic(() =>
      import('./EmailMarketingOneTimePayment').then((mod) => mod.EmailMarketingOneTimePayment),
    ),
    importChunk: () => import('./EmailMarketingOneTimePayment'),
  },
  [ScreenType.TRIAL_PAYMENT_ATTACHMENT_STYLE_V3]: {
    Screen: dynamic(() =>
      import('./TrialPaymentIntroOffers').then((mod) => mod.TrialPaymentIntroOffers),
    ),
    importChunk: () => import('./TrialPaymentIntroOffers'),
  },
  [ScreenType.TRIAL_PAYMENT_INTRO_OFFERS]: {
    Screen: dynamic(() =>
      import('./TrialPaymentIntroOffers').then((mod) => mod.TrialPaymentIntroOffers),
    ),
    importChunk: () => import('./TrialPaymentIntroOffers'),
  },
  [ScreenType.W2A_PROMOTION]: {
    Screen: dynamic(() => import('./W2APromotion').then((mod) => mod.W2APromotion)),
    importChunk: () => import('./W2APromotion'),
  },
  [ScreenType.GENDER_V3]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.GenderV3)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.EMAIL_MARKETING]: {
    Screen: dynamic(() => import('./EmailMarketing').then((mod) => mod.EmailMarketing)),
    importChunk: () => import('./EmailMarketing'),
  },
  [ScreenType.USER_AGE]: {
    Screen: dynamic(() => import('./UserAge').then((mod) => mod.UserAge)),
    importChunk: () => import('./UserAge'),
  },
  [ScreenType.PRELANDING]: {
    Screen: dynamic(() => import('./Prelanding').then((mod) => mod.Prelanding)),
    importChunk: () => import('./Prelanding'),
  },
  [ScreenType.ZODIAC_CARD]: {
    Screen: dynamic(() => import('./ZodiacCard').then((mod) => mod.ZodiacCard)),
    importChunk: () => import('./ZodiacCard'),
  },
  [ScreenType.PERSONALIZED_ANIMATED_CARD]: {
    Screen: dynamic(() =>
      import('./PersonalizedAnimatedCard').then((mod) => mod.PersonalizedAnimatedCard),
    ),
    importChunk: () => import('./PersonalizedAnimatedCard'),
  },
  [ScreenType.SIGNUP]: {
    Screen: dynamic(() => import('./Signup').then((mod) => mod.Signup)),
    importChunk: () => import('./Signup'),
  },
  [ScreenType.PURCHASE_LANDING]: {
    Screen: dynamic(() => import('./PurchaseLanding').then((mod) => mod.PurchaseLanding)),
    importChunk: () => import('./PurchaseLanding'),
  },
  [ScreenType.BEFORE_QUIZ_LANDING]: {
    Screen: dynamic(() => import('./BeforeQuizLanding').then((mod) => mod.BeforeQuizLanding)),
    importChunk: () => import('./BeforeQuizLanding'),
  },
};
